// ─── Job Pipelines (operations microservice) ──────────────────────────────────

export type CorePhase =
  | 'DRAFT'
  | 'SCHEDULED'
  | 'IN_PROGRESS'
  | 'ON_HOLD'
  | 'COMPLETED'
  | 'INVOICED'
  | 'CLOSED'
  | 'CANCELLED'
  | 'ARCHIVED';

export type JobStageTrigger =
  | 'VISIT_SCHEDULED'
  | 'VISIT_DISPATCHED'
  | 'VISIT_STARTED'
  | 'VISIT_HELD'
  | 'ALL_VISITS_COMPLETED'
  | 'OCCURRENCE_COMPLETED'
  | 'INVOICE_ISSUED'
  | 'PAYMENT_RECEIVED';

export interface PipelineStage {
  id: string;
  name: string;
  corePhase: CorePhase;
  sortOrder: number;
  color?: string | null;
  isTerminal?: boolean;
  trigger?: JobStageTrigger | null;
  triggerQualifier?: string | null;
}

export interface JobPipeline {
  id: string;
  tenantId?: string;
  name: string;
  isDefault?: boolean;
  archivedAt?: string | null;
  stages: PipelineStage[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreatePipelineDto {
  name: string;
  isDefault?: boolean;
  stages?: Array<Omit<PipelineStage, 'id'>>;
}

export type UpdatePipelineDto = Partial<Pick<JobPipeline, 'name' | 'isDefault'>>;

export interface CreateStageDto {
  name: string;
  corePhase: CorePhase;
  sortOrder: number;
  color?: string;
  isTerminal?: boolean;
  trigger?: JobStageTrigger | null;
  triggerQualifier?: string | null;
}

export type UpdateStageDto = Partial<CreateStageDto>;

export const CORE_PHASE_COLORS: Record<CorePhase, string> = {
  DRAFT: '#d8d7d3',
  SCHEDULED: '#d9e5f2',
  IN_PROGRESS: '#eedccf',
  ON_HOLD: '#f3e8c9',
  COMPLETED: '#dcebdd',
  INVOICED: '#e6ddf0',
  CLOSED: '#c9c8c4',
  CANCELLED: '#f0d9d8',
  ARCHIVED: '#e8e6e1',
};

export const CORE_PHASES: CorePhase[] = [
  'DRAFT',
  'SCHEDULED',
  'IN_PROGRESS',
  'ON_HOLD',
  'COMPLETED',
  'INVOICED',
  'CLOSED',
  'CANCELLED',
  'ARCHIVED',
];
